import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs';
import {fadeInOutTranslate} from '../../shared/elements/animation';
import swal from 'sweetalert2';
import { SqueezeBox } from 'squeezebox';
import { AssignmentAlgorithmService } from '../algorithm/assignment-algorithm.service';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import { LogisticsService } from '../shared/logistics.service';
import { SessionService } from 'app/sessions/session.service';

@Component({
  selector: 'app-view-shipment-details',
  templateUrl: './view-shipment-details.component.html',
  styleUrls: ['./view-shipment-details.component.css'],
  providers:[AngularFireDatabase,NotificationToastService,SqueezeBox, AssignmentAlgorithmService, DateService],
  animations: [fadeInOutTranslate],
  encapsulation: ViewEncapsulation.None
})
export class ViewShipmentDetailsComponent implements OnInit {

  private myForm: FormGroup;
  myFormBranch:FormGroup;
  myFormItem: FormGroup;
  submittedItem: boolean = false;
  private shipmentId:string;
  submitted : boolean = false;
  hasError : boolean ;
  editProfile = true;
  editProfileIcon = 'icofont-edit';
  shipmentData : Observable<any>;
  shipment: any;
  items:any;
  editing = {};
  rows = [];
  isAutomatic: any;
  submittedAddress:boolean = false;
  private total = 0;
  paths:any;
  isItemExists: boolean = false;
  qrcode:any;
  isFromFinance:boolean = false;
  cities:any;
  citiyList:any;
  today: any;
  time:any;
  branchList:any;
  branchArray:any;
  declineHistory:any;
  myFormTransfer:any;
  currency:any;
  isAuto:boolean = false;
  changeDB:boolean = false;
  public selectedPerson;
  public deliveryBoys : any;
  public supervisors: any;
  rowId:any = null;
  isEditable:boolean = false;
  constructor(private route: ActivatedRoute, public db:AngularFireDatabase, private nf: NotificationToastService, 
    private algorithm: AssignmentAlgorithmService, private dateService:DateService, private logisticsService:LogisticsService,
    public ss:SessionService
    ) {
    var data = this.route.snapshot.queryParamMap.get('key');
    var from = this.route.snapshot.queryParamMap.get('from');
    if(from == "finance")
    {
      this.isFromFinance = true;
    }
    this.shipmentId = data;
    this.initializeForm();
    this.initializeItemForm();
    this.initializeTransferForm();
    this.getUserDetails();
    this.items = [];
   }

  ngOnInit() {
    firebase.database().ref("autoAssign").on("value",(data)=>{
      this.isAutomatic = data.val();
    });
    //document.getElementById('edit').style.pointerEvents = 'none';
    this.getUser();
    this.getTransitHistory();
    this.getDeclineHistory();
    this.getCities();
    this.getTimeandDate();
    this.getAllBranch();
    this.getSettings();
    this.getSupervisors();
    this.getDeliveryBoys();
  }
  initializeTransferForm()
  {
    this.myFormTransfer = new FormGroup({
      branchTransfer: new FormControl('',Validators.required)
    });
    this.myFormTransfer.reset();
  }
  initializeForm()
  {
    this.myForm = new FormGroup({
      sourceName: new FormControl('', Validators.required),
      sourceCode: new FormControl('', Validators.required),
      sourcePhone: new FormControl(''),
      sourceAddress1: new FormControl(''),
      sourceAddress2: new FormControl(''),
      sourceCity: new FormControl('', Validators.required),
      pickupDate: new FormControl(''),
      destinationName: new FormControl('', Validators.required),
      destinationCode: new FormControl('', Validators.required),
      destinationPhone: new FormControl(''),
      destinationAddress1:new FormControl(''),
      destinationAddress2: new FormControl(''),
      destinationCity: new FormControl('', Validators.required),
      deliveryDate: new FormControl(''),
      sourcePincode: new FormControl(''),
      destinationPincode: new FormControl(''),
      total: new FormControl('')
    });
    this.edit();
    this.myForm.reset();

    //branch form
    this.myFormBranch =  new FormGroup({
      branch : new FormControl('', Validators.required)
    });
    this.myFormBranch.reset();
  }
  private edit()
  {
    this.db.object('/shipments/' + this.shipmentId)
    .subscribe(shipment =>{
      this.total  = shipment.total;
      this.myForm = new FormGroup({
        sourceName: new FormControl(shipment.source.name, Validators.required),
        sourceCode: new FormControl(shipment.source.code, Validators.required),
        sourcePhone: new FormControl(shipment.source.phoneNumber, Validators.required),
        sourceAddress1: new FormControl(shipment.source.addressLine1),
        sourceAddress2: new FormControl(shipment.source.addressLine2),
        sourceCity: new FormControl(shipment.source.cityId, Validators.required),
        destinationName: new FormControl(shipment.destination.name, Validators.required),
        destinationCode: new FormControl(shipment.destination.code, Validators.required),
        destinationPhone: new FormControl(shipment.destination.phoneNumber, Validators.required),
        destinationAddress1:new FormControl(shipment.destination.addressLine1),
        destinationAddress2: new FormControl(shipment.destination.addressLine2),
        destinationCity: new FormControl(shipment.destination.cityId, Validators.required),
        pickupDate: new FormControl(shipment.source.date),
        deliveryDate: new FormControl(shipment.destination.date),
        sourcePincode: new FormControl(shipment.source.pincode),
        destinationPincode: new FormControl(shipment.destination.pincode),
        total: new FormControl(shipment.total)
      });
      if(shipment.source.code == "+966")
      {
        this.maxLength1 = 9;
        this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      }
      else
      {
        this.maxLength1 = 10;
        this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      }
      if(shipment.destination.code == "+966")
      {
        this.maxLength2 = 9;
        this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      }
      else
      {
        this.maxLength2 = 10;
        this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      }
    });
  } 
  phone_error1:boolean = false;
  phone_error2:boolean = false;
onSubmit()
{
this.hasError = false;
this.submitted = true;
this.phone_error1 = false;
    this.phone_error2 = false;
    var phone1 = this.myForm.value.sourcePhone;
    var phone2 = this.myForm.value.destinationPhone;
    if(phone1.length != this.maxLength1)
      {
        this.phone_error1 = true;
        return;
      }
      else if(phone2.length != this.maxLength2)
      {
        this.phone_error2 = true;
        return;
      }
    else if(this.myForm.valid) {
  //console.log(this.myForm.value);
  //var date = new Date();
  //var today = date.getDate()+"/"+(date.getMonth() + 1)+"/"+date.getFullYear();
  let source = {
    name : this.myForm.value.sourceName,
    code: this.myForm.value.sourceCode,
    phoneNumber : this.myForm.value.sourcePhone,
    addressLine1 : this.myForm.value.sourceAddress1,
    addressLine2: this.myForm.value.sourceAddress2,
    // city: this.myForm.value.sourceCity,
    // pincode: this.myForm.value.sourcePincode
    date:this.myForm.value.pickupDate,
    pincode:this.citiyList[this.myForm.value.sourceCity].pincode,
    city:this.citiyList[this.myForm.value.sourceCity].name,
    lat:this.citiyList[this.myForm.value.sourceCity].lat,
    lng:this.citiyList[this.myForm.value.sourceCity].lng,
    cityId: this.myForm.value.sourceCity
  }
  let destination = {
    name : this.myForm.value.destinationName,
    code: this.myForm.value.destinationCode,
    phoneNumber : this.myForm.value.destinationPhone,
    addressLine1:this.myForm.value.destinationAddress1,
    addressLine2: this.myForm.value.destinationAddress2,
    // city: this.myForm.value.destinationCity,
    // pincode: this.myForm.value.destinationPincode
    date:this.myForm.value.deliveryDate,
    pincode:this.citiyList[this.myForm.value.destinationCity].pincode,
    city:this.citiyList[this.myForm.value.destinationCity].name,
    lat:this.citiyList[this.myForm.value.destinationCity].lat,
    lng:this.citiyList[this.myForm.value.destinationCity].lng,
    cityId: this.myForm.value.destinationCity
  }
  var date_time = this.dateService.getTimeandDate();
      var usersRef = firebase.database().ref("shipments");
      usersRef.child(this.shipmentId).update({
        source:source,
        destination:destination,
        updatedAt: date_time.date,
        updatedTime: date_time.time
      }).then(
        (success) => {
          //console.log("success creation");
          this.submitted = false;
          this.myForm.reset();
          this.myForm.controls["sourceCode"].setValue('+966');
          this.myForm.controls["destinationCode"].setValue('+966');
          this.nf.addToast({title:'Update Success', msg:'Shipment data has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});   
          this.toggleEditProfile(); 
          this.algorithm.assignToBranch(this.shipmentId,source.lat,source.lng);
        });
    } 
}
toggleEditProfile() {
  this.editProfileIcon = (this.editProfileIcon === 'icofont-close') ? 'icofont-edit' : 'icofont-close';
  this.editProfile = !this.editProfile;
  if(this.editProfileIcon == 'icofont-edit')
  this.edit();
}
public getUser()
        {
      this.shipmentData = this.db.object("shipments/"+this.shipmentId);
      this.shipmentData.subscribe(shipment=>{
      this.items =[];
      //console.log("userData ",shipment);
      this.shipment = shipment;
      if(shipment.items)
      {
        this.items = shipment.items;
        this.isItemExists = true;
      }
      else
      {
        this.isItemExists = false;
      }
      this.isEditable = (this.shipment.branch == this.ss.getUserBranch)?true:(this.ss.getUserRole == 'super admin')? true:false;
    });
        }
        
        updateValue(event, cell, cellValue, row) {
          this.editing[row.$$index + '-' + cell] = false;
          this.items[row.$$index][cell] = event.target.value;
          if(cell == "quantity" || cell == "price")
          {
            this.items[row.$$index]["total"] = this.items[row.$$index]["quantity"] * this.items[row.$$index]["price"];
          }
          this.total = 0;
          this.items.forEach(i=>{
            this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
          });
          this.saveUpdatedItems("delete");
        }
        deleteValue(event, row)
        {
          const index = row.$$index;
          swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then(() => {
            this.items.splice(index,1);
            this.total = 0;
            this.saveUpdatedItems("update");
            this.items.forEach(i=>{
              this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
    });
            swal({
              title:'Deleted!',
              text: 'Your file has been deleted.',
              type: 'success'
            })
          }).catch(swal.noop);
        }
        

        saveUpdatedItems(type)
        {
          this.total = 0;
          var items = [];
          this.items.forEach(i=>{
            this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
            items.push({
              id: i.id,
              item: i.item,
              description: i.description,
              quantity: i.quantity,
              price: i.price,
              total: i.total
            });
          });
          //console.log(items);
          var usersRef = firebase.database().ref("shipments");
          usersRef.child(this.shipmentId).update({
            items: items,
            total: this.total
          }).then(
          (success) => {
            //console.log("success creation");
            if(type == "add")   
            {
              this.toggleEditProfile(); 
              this.nf.addToast({title:'Item Added', msg:'Item has been added', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
            }
            else if(type == "update")
            {
              this.nf.addToast({title:'Item Update Success', msg:'Item has been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
            }
            else
            {
              this.nf.addToast({title:'Item Delted', msg:'Item has been deleted', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
            }
          });
        }

        saveTotal()
        {
          var usersRef = firebase.database().ref("shipments");
          usersRef.child(this.shipmentId).update({
            total: this.total
          }).then(
          (success) => {
            //console.log("success creation");
            this.nf.addToast({title:'Total Update Success', msg:'Total been updated', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});   
            this.toggleEditProfile(); 
          });
        }
        loadPaths()
        {
          this.paths= [{
            date: "25-Oct-2018",
            time:	"04:12 am",
            wearHouse:	"JIGANI ETAIL CPU",
            status:	"SHIPMENT ARRIVED"
          },
          {
            date: "25-Oct-2018",
            time:	"10:03 pm",
            wearHouse:	"JIGANI ETAIL CPU",
            status:	"SHIPMENT FURTHER CONNECTED"
          },
          {
            date: "26-Oct-2018",
            time:	"02:15 am",
            wearHouse:	"BANGALORE HUB",
            status:	"SHIPMENT ARRIVED AT HUB"
          },
          {
            date: "26-Oct-2018",
            time:	"11:45 pm",
            wearHouse:	"BANGALORE HUB",
            status:	"SHIPMENT ARRIVED AT HUB"
          },
          {
            date: "27-Oct-2018",
            time:	"09:18 am",
            wearHouse:	"ATTAVARA SERVICE CENTRE",
            status:	"SHIPMENT ARRIVED"
          },
          {
            date: "27-Oct-2018",
            time:	"10:59 am",
            wearHouse:	"ATTAVARA SERVICE CENTRE",
            status:	"SHIPMENT ARRIVED AT HUB"
          },
          {
            date: "27-Oct-2018",
            time:	"11:34 am",
            wearHouse:	"ATTAVARA SERVICE CENTRE",
            status:	"	SHIPMENT DELIVERED"
          },
        ]
        }
        getTransitHistory()
        {
          this.paths = this.db.list("shipments/"+this.shipmentId+"/transitHistory");
        }
        getDeclineHistory()
        {
          this.declineHistory = this.db.list("shipments/"+this.shipmentId+"/declineHistory");
        }
  initializeItemForm()
  {
    this.myFormItem = new FormGroup({
      item:  new FormControl('', Validators.required),
      quantity: new FormControl('', Validators.required),
      description: new FormControl('', Validators.required),
      price: new FormControl('', Validators.required),
    });
  }

onSubmitItem()
{
  this.submittedItem = true;
  //console.log(this.myFormItem.value);
  if(!this.isItemExists)
  {
    this.items =[];
  }
  if(this.myFormItem.valid)
  {
    this.total = 0;
    var key = firebase.database().ref("items").push().key;
    var itemTotal = this.myFormItem.value.quantity * this.myFormItem.value.price;
    this.items.push({
      id: key,
      item: this.myFormItem.value.item,
      quantity: this.myFormItem.value.quantity,
      description: this.myFormItem.value.description,
      price: this.myFormItem.value.price,
      total : itemTotal
    });
    this.myFormItem.reset();
    this.submittedItem = false;
    this.submitted = false;
    this.items.forEach(i => {
      this.total = this.total + (parseInt(i.price) * parseInt(i.quantity));
      //console.log("price ",i.price);
    });
    this.saveUpdatedItems("add");
    this.myForm.setControl("total", new FormControl(this.total));
  }
}
qrCode(e,id)
{
  document.querySelector("#" + e).classList.add('md-show');
  this.qrcode = id;
}
closeMyModal(e)
{
  document.querySelector("#" + e).classList.remove('md-show');
}
getCities()
  {
    var city = this.db.list("cities");
    city.subscribe(item=>{
    this.cities = [];
    this.citiyList = [];
    item.forEach(element =>{
      //console.log("element",element);
        var y = element;
        this.cities.push(y);
        this.citiyList[element.$key] = element;
    });
  });
  }
  getTimeandDate()
  {
    var today = new Date();
    var dd = String(today.getDate());
    var mm = String(today.getMonth() + 1); //January is 0!

    var yyyy = today.getFullYear();
    /* if (Number(dd) < 10) {
      dd = '0' + dd;
    } 
    if (Number(mm) < 10) {
      mm = '0' + mm;
    } */ 
    var t =  dd + '/' + mm + '/' + yyyy;
    this.today = dd + '/' + mm + '/' + yyyy;
    var hours = today.getHours();
    var minutes = today.getMinutes();
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var h = hours < 10 ? '0'+hours : hours;
    var m = minutes < 10 ? '0'+minutes : String(minutes);
    this.time = h + ':' + m + ' ' + ampm;
  }
  getAllBranch()
  {
    firebase.database().ref("branches").orderByChild("status").equalTo("active").once("value").then((branch)=>{
      var branch = branch.val();
      this.branchList = [];
      this.branchArray = [];
      for(let i in branch)
      {
        var data = branch[i];
        //console.log("data", data);
        data["$key"] = i;
        this.branchList.push(data);
        this.branchArray[i] = data;
        //console.log("branchList", this.branchList,this.branchArray);
      }
    });
  }
  user:any
  getUserDetails()
  {
    firebase.database().ref("users").child(localStorage.getItem("courierapp_user_id")).once("value",(user)=>{
      this.user = user.val();
    });
  }
maxLength1: number;
maxLength2: number;
  onChangeSourceCountry(e)
  {
    //console.log(e.target.value);
    this.phone_error1 = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength1  = 10;
      this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      //console.log(this.maxLength1);
      break;
      case "+966" : this.maxLength1  = 9;
      this.myForm.controls["sourcePhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      //console.log(this.maxLength1);
      break;
    }
  }
  
  onChangeDestinationCountry(e)
  {
    //console.log(e.target.value);
    this.phone_error2 = false;
    switch(e.target.value)
    {
      case "+91" : this.maxLength2  = 10;
      this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(10),Validators.maxLength(10)]);
      //console.log(this.maxLength2);
      break;
      case "+966" : this.maxLength2  = 9;
      this.myForm.controls["destinationPhone"].setValidators([Validators.minLength(9),Validators.maxLength(9)]);
      //console.log(this.maxLength2);
      break;
    }
  }
  private keyPressSource(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone1 = this.myForm.value.sourcePhone;
      if(phone1.length >= this.maxLength1)
      {
        event.preventDefault();
      }
    }
  }
 keyPressDestination(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    else
    {
      var phone2 = this.myForm.value.destinationPhone;
      if(phone2.length >= this.maxLength2)
      {
        event.preventDefault();
      }
    }
  }
  keyPress1(event)
{
  const pattern = /[0-9\+\-\ ]/;
  let inputChar = String.fromCharCode(event.charCode);
  if (event.keyCode != 8 && !pattern.test(inputChar)) {
    event.preventDefault();
  }
}
advance_amount: Number;
collect_submitted: boolean = false;
collectAdvance()
{
  this.collect_submitted = true;
  //console.log("cash collected",this.advance_amount);
  var amount;
  if(this.shipment.cashCollected)
  {
     amount = this.shipment.cashCollected + Number(this.advance_amount);
  }
  else
  {
     amount = Number(this.advance_amount);
  }
  
  firebase.database().ref("shipments").child(this.shipmentId).child("cashCollected").set(amount).then(()=>{
    this.advance_amount = null;
    var userName;
    firebase.database().ref("users").child(localStorage.getItem('courierapp_user_id')).once("value").then((user)=>{
      userName = user.child("name").val();
      firebase.database().ref("shipments").child(this.shipmentId).child("cashCollectedHistory").push({
        amount : amount,
        date: this.today,
        time: this.time,
        userId: localStorage.getItem('courierapp_user_id'),
        userName: userName
      }).then(()=>{
        this.advance_amount = null;
        firebase.database().ref("users").child(localStorage.getItem('courierapp_user_id')).child("cashCollectedHistory").push({
          amount : amount,
          date: this.today,
          time: this.time,
          shipmentId: this.shipmentId
        });
      });
    });
  });
}
paymentOption : any;
getSelectedPaymentOption(event)
{
  //console.log(event.target.value);
  this.paymentOption  = event.target.value;
  
}
setpaymentOption()
{
  this.paymentEdit = false;
  //console.log(this.paymentOption);
  firebase.database().ref("shipments").child(this.shipmentId).child("paymentOption").set(this.paymentOption);
}
paymentEdit: boolean = false;
editPaymentOption()
{
  this.paymentEdit = true;
}
transferOrder()
{
  if(this.myFormTransfer.valid)
  {
    var date_time = this.dateService.getTimeandDate();
    var branch = this.myFormTransfer.value.branchTransfer;
    var data = {
      branch : branch,
      status : 11
    }
    firebase.database().ref("shipments").child(this.shipmentId).update(data);
    var branchTransferHistory = {
      from: this.shipment.branch,
      to: branch,
      admin : localStorage.getItem("courierapp_user_id"),
      date: date_time.date,
      time: date_time.time,
      shipmentId: this.shipmentId,
      status: "Branch Transfer",
      userName: this.user.name
    }
    firebase.database().ref("branchTransferHistory").push(branchTransferHistory);
    firebase.database().ref("shipments").child(this.shipmentId).child("transitHistory").push(branchTransferHistory);
    this.myFormTransfer.reset();
    firebase.database().ref("shipments").child(this.shipmentId).child("items").once("value").then((data)=>{
      
      var items = data.val();
      //console.log("data",items);
      var itemsList = [];
      for(let i in items)
      {
        var y = items[i];
        //console.log("y",y);
        y["barcodeScannedStatus"] = "transfer";
        var barcodes = items[i].barcodes;
        var barcodeList = [];
        for(let i in barcodes)
        {
          var barcode = barcodes[i];
          barcode["scannedStatus"] = "transfer";
          barcodeList.push(barcode);
        }
        y["barcodes"] = barcodeList;
        itemsList.push(y);
      }
      firebase.database().ref("shipments").child(this.shipmentId).child("items").update(itemsList);
    });
  }
}
getSettings()
     {
      firebase.database().ref("settings").child("general").on("value",(generalSetting)=>{
        this.currency =  generalSetting.child('currency').val();
      });
      firebase.database().ref("settings").child("shipment").once("value").then((data)=>{
        if(data.child("routing").val() == 'Auto')
        {
          this.isAuto = true;
        }
        else
        {
          this.isAuto = false;
        }
      });
     }
     outForDelivery(shipmentId)
  {
    //console.log("outForDelivery",shipmentId);
    this.logisticsService.outForDeliveryAssignDeliveryBoy(shipmentId);
  }
  outForTransferShipmentId:any;
  outForTransferShipmentBranch:any;
  outForTransfer(shipmentId,shipmentBranch,event)
    {
      this.outForTransferShipmentId = shipmentId;
      this.outForTransferShipmentBranch = shipmentBranch;
      document.querySelector("#" + event).classList.add('md-show');
    }

    onSubmitBranch()
  {
    var event = 'effect-2';
    //console.log("myFormBranch onSubmitBranch");
    if(this.myFormBranch.valid)
    {
      //console.log("myFormBranch",this.myFormBranch.value.branch);
      document.querySelector("#" + event).classList.remove('md-show');
      var branch = this.myFormBranch.value.branch;
      var date_time = this.dateService.getTimeandDate();
      this.logisticsService.transferOrder(branch,this.outForTransferShipmentId,this.user,this.outForTransferShipmentBranch,date_time)
    }
  }
  invoice(id)
  {
    //window.open("http://paarseldev.com/invoice/"+id, '_blank');
    window.open("http://paarsel.com/invoice/"+id, '_blank');
  }
  wayBill(id)
  {
    window.open("http://paarsel.com/inv/"+id, '_blank');
  }
  acceptOrder(id)
  {
    this.logisticsService.acceptOrder(id);
    this.nf.addToast({title:'Status Update', msg:'Order Accepted', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
  }
  declineOrder(id)
  {
    this.logisticsService.declineOrder(id);
    this.nf.addToast({title:'Status Update', msg:'Order Declined', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
  }
  changeDeliveryBoy(id)
  {
    this.changeDB = true;
    this.rowId = id;
  }
  getSelectedDeliveryBoy(e)
  {
    this.selectedPerson = e.target.value;
  }
  assignSupervisorForShipment(id,branch)
  {
    this.assignDeliveryBoy(id,branch,3,'supervisor');
  }
  assignDeliveryBoy(id,branch,status,role)
  {
    if(this.selectedPerson != null)
    {
      var date_time = this.dateService.getTimeandDate();
      this.logisticsService.assignDeliveryBoy(id,this.selectedPerson,branch, date_time.date, date_time.time,status,role);
      this.changeDB = false;
      this.rowId = null;
      this.selectedPerson = null;
  }
  else
  {
    this.changeDB = false;
    this.rowId = null;
  }
  }
  assignDeliveryBoyForShipment(id,branch)
  {
    this.assignDeliveryBoy(id,branch,6,'driver');  
  }
  getDeliveryBoys()
  {
    //console.log("on branch selected");
    var deliveryBoys= this.logisticsService.getDrivers();
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
      deliveryBoys.snapshotChanges().subscribe(item=>{
        this.deliveryBoys = [];
        item.forEach(element =>{
          if(element.payload.child("status").val() == 1)
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.deliveryBoys.push(y);
          }
        });
      });
    }
    else
    {
      deliveryBoys.snapshotChanges().subscribe(item=>{
        this.deliveryBoys = [];
        item.forEach(element =>{
          if(element.payload.child("branch").val() == localStorage.getItem("branch"))
          {
          if(element.payload.child("status").val() == 1)
          {
            var y = element.payload.toJSON();
            y["$key"] = element.key;
            this.deliveryBoys.push(y);
          }
          }
        });
      });
    }
  }
  getSupervisors()
  {
    var supervisors= this.logisticsService.getSupervisors();
    if(localStorage.getItem("courierapp_role") == "super admin")
    {
    supervisors.snapshotChanges().subscribe(item=>{
      this.supervisors = [];
      item.forEach(element =>{
        if(element.payload.child("status").val() == 1)
          {
        var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.supervisors.push(y);

          }
      });
    });
  }
  else
  {
    supervisors.snapshotChanges().subscribe(item=>{
      this.supervisors = [];
      item.forEach(element =>{
        if(element.payload.child("branch").val() == localStorage.getItem("branch"))
        {
          if(element.payload.child("status").val() == 1)
          {
         var y = element.payload.toJSON();
          y["$key"] = element.key;
          this.supervisors.push(y);
          }
        }
      });
    });
  }
  }
}


// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/view-shipment-details/view-shipment-details.component.ts